<template>
    <section>
        <!--工具条-->
        <el-col :span="24" style="padding-bottom: 0;" size="small">
            <el-form :inline="true" :model="filters">
                <el-form-item>
                    <el-autocomplete v-model="filters.account" :fetch-suggestions="querySearch" size="small" placeholder="用户名" :disabled="!isUser"></el-autocomplete>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" v-on:click="queryBtn()" size="small" icon="el-icon-search" :disabled="!isDepot">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleAdd" size="small" icon="el-icon-plus" :disabled="!isAuth('depot:add')">新增</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <!--列表-->
        <el-table :data="depotList" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;" size="small">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="index" width="60" :index="indexMethod"></el-table-column>
            <el-table-column prop="account" label="用户名" width="120" align="center"></el-table-column>
            <el-table-column prop="model" label="设备类型" width="500" align="center"></el-table-column>
            <el-table-column prop="feature" label="功能" width="150" align="center"></el-table-column>
            <el-table-column prop="licence" label="licence" width="180" align="center"></el-table-column>
            <el-table-column prop="price" label="价格" min-width="150" align="center"></el-table-column>
            <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)" :disabled="!isAuth('depot:update')">编辑</el-button>
                    <el-button type="text" size="small" @click="handleDel(scope.$index, scope.row)" :disabled="!isAuth('depot:del')">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24">
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10"
                :total="total" :current-page.sync="page" style="float:right;">
            </el-pagination>
        </el-col>

        <!--编辑界面-->
        <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false" width="30%">
            <el-form :model="editForm" label-width="80px" ref="editForm" :rules="editFormRules" size="small">
                <el-form-item label="用户名" prop="account">
                    <el-input v-model="editForm.account" auto-complete="off" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="设备类型" prop="model">
                    <el-select v-model="editForm.model" placeholder="请选择设备类型" style="width:100%" disabled>
                        <el-option v-for="device in deviceList" :value="device.board" :label="device.type" :key="device.board"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="功能" prop="feature">
                    <el-select v-model="editForm.feature" auto-complete="off" placeholder="请选择" style="width:100%" disabled>
                        <el-option v-for="func in funcList" :value="editForm.isNew===1?parseInt(func.bit):Math.pow(2,parseInt(func.bit))" :label="func.feature"
                            :key="func.bit"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="licence" prop="licence">
                    <el-input v-model="editForm.licence" auto-complete="off" type="number" min="0"  :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="价格" prop="price">
                    <el-input v-model="editForm.price" auto-complete="off" type="number" min="0"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false" size="small">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading" size="small">提交</el-button>
            </div>
        </el-dialog>

        <!--新增界面-->
        <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false" width="30%">
            <el-form :model="addForm" label-width="80px" ref="addForm" size="small" :rules="addFormRules">
                <el-form-item label="用户名" prop="account">
                    <el-select v-model="addForm.account" style="width:100%">
                        <el-option v-for="user in users" v-bind:value="user.value" :key="user.value">{{user.value}}</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备类型" prop="model">
                    <el-select v-model="addForm.model" placeholder="请选择设备类型" style="width:100%">
                        <el-option v-for="device in deviceList" :value="device.board" :label="device.type" :key="device.board"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="功能" prop="feature">
                    <el-select v-model="addForm.feature" auto-complete="off" placeholder="请选择" style="width:100%">
                        <el-option v-for="func in funcList" :value="parseInt(func.bit)" :label="func.feature"
                            :key="func.bit"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="licence" prop="licence">
                    <el-input v-model="addForm.licence" auto-complete="off" type="number" min="0" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="价格" prop="price">
                    <el-input v-model="addForm.price" auto-complete="off" type="number" min="0"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false" size="small">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading" size="small">提交</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
import {
  getDepotInfo,
  getDepotList,
  listUsername,
  addDepot,
  editDepot,
  removeDepot,
  getDeviceInfo,
  getFeatureInfo, getContractList
} from "../../../api/api";
    import { isAuth } from "../../../utils";

    export default {
        data() {
            return {
                filters: {
                    account: ''
                },
                curUser: '',
                isDepot: false,
                isUser: false,
                depotList: [],
                users: [],
                deviceList: [],
                funcList: [],
                total: 0,
                page: 1,
                listLoading: false,
                sels: [], //列表选中列

                editFormVisible: false, //编辑界面是否显示
                editLoading: false,
                //编辑界面数据
                editForm: {
                    id: '',
                    account: '',
                    model: '',
                    feature: '',
                    price: '',
                    licence: ''
                },
                editFormRules: {
                    account: [{
                        required: true,
                        message: '请选择用户',
                        trigger: 'change'
                    }],
                    model: [{
                        required: true,
                        message: '请选择设备类型',
                        trigger: 'change'
                    }],
                    feature: [{
                        required: true,
                        message: '请选择功能',
                        trigger: 'change'
                    }],
                    price: [{
                            required: true,
                            message: '请输入价格',
                            trigger: 'blur'
                        },
                        {
                            pattern: /^([1-9]\d*|[0]{1,1})$/,
                            message: '不能输入小数和负数'
                        }
                    ],
                    licence: [{
                            required: true,
                            message: '请输入licence',
                            trigger: 'blur'
                        },
                        {
                            pattern: /^([1-9]\d*|[0]{1,1})$/,
                            message: '不能输入小数和负数'
                        }
                    ]
                },

                addFormVisible: false, //新增界面是否显示
                addLoading: false,
                //新增界面数据
                addForm: {
                    account: '',
                    model: '',
                    feature: '',
                    price: '',
                    licence: 0
                },
                addFormRules: {
                    account: [{
                        required: true,
                        message: '请选择用户',
                        trigger: 'change'
                    }],
                    model: [{
                        required: true,
                        message: '请选择设备类型',
                        trigger: 'change'
                    }],
                    feature: [{
                        required: true,
                        message: '请选择功能',
                        trigger: 'change'
                    }],
                    price: [{
                            required: true,
                            message: '请输入价格',
                            trigger: 'blur'
                        },
                        {
                            pattern: /^([1-9]\d*|[0]{1,1})$/,
                            message: '不能输入小数和负数'
                        }
                    ],
                    licence: [{
                            required: true,
                            message: '请输入licence',
                            trigger: 'blur'
                        },
                        {
                            pattern: /^([1-9]\d*|[0]{1,1})$/,
                            message: '不能输入小数和负数'
                        }
                    ]
                }
            }
        },
        methods: {
            querySearch(queryString, cb) {
                let users = this.users;
                let results = queryString ? users.filter(this.createFilter(queryString)) : users;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (user) => {
                    return (user.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            indexMethod(row) {
                return row + (this.page - 1) * 10 + 1
            },
            handleCurrentChange(val) {
                this.page = val;
                if(this.isDepot){
                    this.getDepotList();
                }else{
                    this.getDepotInfo(this.curUser);
                }
            },

            getUsers() {
                listUsername().then((res) => {
                    this.users = res.data.userList;
                })
            },

            getDeviceInfo() {
                getDeviceInfo().then((res) => {
                    this.deviceList = res.data.deviceList.content;
                    this.getFeatureInfo();
                })
            },

            getFeatureInfo() {
                getFeatureInfo().then((res) => {
                    this.funcList = res.data.featureList.content;
                    if(this.isDepot){
                        this.getDepotList();
                    }else{
                        this.getDepotInfo(this.curUser);
                    }
                })
            },
            //获取仓库列表
            getDepotInfo(u) {
                let para = {
                    page: this.page - 1,
                    size: 10,
                    account: u
                };
                this.listLoading = true;
                getDepotInfo(para).then((res) => {
                    if (res.data.code === 0) {
                        this.depotList = res.data.depotList.content;
                        let depot = [];
                        for (let i = 0; i < this.depotList.length; i++) {
                            let depotMap = {};
                            depotMap.id = this.depotList[i].id;
                            depotMap.account = this.depotList[i].account;
                            depotMap.licence = this.depotList[i].licence;
                            depotMap.price = this.depotList[i].price;
                            depotMap.isNew = this.depotList[i].isNew;
                            for (let j = 0; j < this.deviceList.length; j++) {
                                if (this.depotList[i].model === this.deviceList[j].board) {
                                    depotMap.model = this.deviceList[j].type;
                                }
                            }
                            for (let j = 0; j < this.funcList.length; j++) {
                              if(this.depotList[i].isNew===1){
                                if (this.depotList[i].feature === parseInt(this.funcList[j].bit)) {
                                  depotMap.feature = this.funcList[j].feature;
                                }
                              }else{
                                if (this.depotList[i].feature === Math.pow(2, parseInt(this.funcList[j].bit))) {
                                  depotMap.feature = this.funcList[j].feature;
                                }
                              }
                            }
                            depot.push(depotMap);
                        }
                        this.depotList = depot;
                        this.total = res.data.depotList.totalElements;
                    } else {
                        this.$message.error("获取终端用户列表失败，请稍后重新获取")
                    }
                    this.listLoading = false;
                })
            },

          queryBtn(){
            this.page=1;
            this.getDepotList();
          },

            //获取仓库列表
            getDepotList() {
                let para = {
                    page: this.page - 1,
                    size: 10,
                    account: this.filters.account,
                };
                this.listLoading = true;
                getDepotList(para).then((res) => {
                    if (res.data.code === 0) {
                        this.depotList = res.data.depotList.content;
                        let depot = [];
                        for (let i = 0; i < this.depotList.length; i++) {
                            let depotMap = {};
                            depotMap.id = this.depotList[i].id;
                            depotMap.account = this.depotList[i].account;
                            depotMap.licence = this.depotList[i].licence;
                            depotMap.price = this.depotList[i].price;
                            depotMap.isNew = this.depotList[i].isNew;
                            for (let j = 0; j < this.deviceList.length; j++) {
                                if (this.depotList[i].model === this.deviceList[j].board) {
                                    depotMap.model = this.deviceList[j].type;
                                }
                            }
                            for (let j = 0; j < this.funcList.length; j++) {
                              if(this.depotList[i].isNew===1){
                                if (this.depotList[i].feature === parseInt(this.funcList[j].bit)) {
                                  depotMap.feature = this.funcList[j].feature;
                                }
                              }else{
                                if (this.depotList[i].feature === Math.pow(2, parseInt(this.funcList[j].bit))) {
                                  depotMap.feature = this.funcList[j].feature;
                                }
                              }
                            }
                            depot.push(depotMap);
                        }
                        this.depotList = depot;
                        this.total = res.data.depotList.totalElements;
                    } else {
                        this.$message.error("获取终端用户列表失败，请稍后重新获取")
                    }
                    this.listLoading = false;
                })
            },
            //删除
            handleDel: function (index, row) {
                this.$confirm('确认删除该记录吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.listLoading = true;
                    let para = {
                        id: row.id
                    };
                    removeDepot(para).then((res) => {
                        if (res.data.code === 0) {
                            this.$message.success('删除成功');
                            this.getDepotList();
                        } else {
                            this.$message.error('删除失败');
                        }
                        this.listLoading = false;
                    });
                }).catch(() => {

                });
            },
            //显示编辑界面
            handleEdit: function (index, row) {
                this.editFormVisible = true;
                this.editForm = Object.assign({}, row);
            },
            //显示新增界面
            handleAdd: function () {
                this.addFormVisible = true;
            },
            //编辑
            editSubmit: function () {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.editLoading = true;
                            for (let j = 0; j < this.deviceList.length; j++) {
                                if (this.editForm.model == this.deviceList[j].type) {
                                    this.editForm.model = this.deviceList[j].board;
                                }
                            }
                            for (let j = 0; j < this.funcList.length; j++) {
                              if(this.editForm.isNew===1){
                                if (this.editForm.feature == this.funcList[j].feature) {
                                  this.editForm.feature = parseInt(this.funcList[j].bit);
                                }
                              }else{
                                if (this.editForm.feature == this.funcList[j].feature) {
                                    this.editForm.feature = Math.pow(2, parseInt(this.funcList[j].bit))
                                }
                              }
                            }
                            let para = Object.assign({}, this.editForm);
                            editDepot(para).then((res) => {
                                if (res.data.code === 0) {
                                    this.$message.success('修改成功');
                                    if(this.isDepot){
                                        this.getDepotList();
                                    }else{
                                        this.getDepotInfo(this.curUser);
                                    }
                                } else {
                                    this.$message.error('修改失败');
                                }
                                this.editLoading = false;
                                this.$refs['editForm'].resetFields();
                                this.editFormVisible = false;
                            });
                        });
                    }
                })
            },
            //新增
            addSubmit: function () {
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.addLoading = true;
                            let para = {
                                'account': this.addForm.account,
                                'model': this.addForm.model,
                                'feature': this.addForm.feature,
                                'licence': this.addForm.licence,
                                'price': this.addForm.price
                            };
                            addDepot(para).then((res) => {
                                if (res.data.code === 0) {
                                    this.$message.success('添加成功');
                                    if(this.isDepot){
                                        this.getDepotList();
                                    }else{
                                        this.getDepotInfo(this.curUser);
                                    }
                                } else {
                                    this.$message.error('添加失败');
                                }
                                this.addLoading = false;
                                this.$refs['addForm'].resetFields();
                                this.addFormVisible = false;
                            });
                        });
                    }
                })
            },
            selsChange: function (sels) {
                this.sels = sels;
            },
        },
        activated() {
            this.curUser = sessionStorage.getItem("username");
            this.isDepot = isAuth('depot:list');
            this.isUser = isAuth('user:list');
            this.getUsers();
            if(!this.isDepot){
                this.filters.account = this.curUser;
            }
            this.getDeviceInfo();
        }
    }
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/modules/conf/dep.vue